import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Banner } from './Banner';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('completed', {
    _component: () => Banner,
  }, overrideReadOnly)
  .done();
